import { RouteObject } from "react-router-dom";
import { AppLayout } from "../components/layouts/appLayout";
import { AuthLayout } from "../components/layouts/authLayout";
import { PlainLayout } from "../components/layouts/plainLayout";
import { Protected } from "../components/layouts/protected";
import { Approvals } from "../pages/app/approvals";
import { SingleCooperativeApproval } from "../pages/app/approvals/singleCooperativeApproval";
import { Invitation } from "../pages/app/invitation";
import { LoanGuarantorInvitation } from "../pages/app/invitation/loanGuarantorInvite";
import { JoinCooperative } from "../pages/app/joinCooperative";
import { MyCooperatives } from "../pages/app/mycooperatives";
import { SingleMyCooperative } from "../pages/app/mycooperatives/singleCooperative";
import { ViewLoanDetailsPage } from "../pages/app/mycooperatives/singleCooperative/loans/viewLoandetails";
import { Overview } from "../pages/app/overview/overview";
import { Settings } from "../pages/app/settings";
import { MembershipSettingsEdit } from "../pages/app/settings/membershipSettings/edit";
import { ProfileEdit } from "../pages/app/settings/profileSettings/profileEdit";
import { ForgotPassword } from "../pages/auth/forgotPassword/forgotPassword";
import { SignIn } from "../pages/auth/signIn";
import { SignUp } from "../pages/auth/signup/signUp";
import { Error404Page } from "../pages/error/error404Page";
import { ErrorBoundary } from "../pages/error/errorBoundary";

export const appRoutes: RouteObject[] = [
  {
    path: "/",
    errorElement: <ErrorBoundary />,
    children: [
      {
        index: true,
        path: "",
        element: (
          <AuthLayout>
            <SignIn />
          </AuthLayout>
        ),
      },
      {
        path: "auth/sign-in",
        element: (
          <AuthLayout>
            <SignIn />
          </AuthLayout>
        ),
      },
      {
        path: "auth/forgot-password",
        element: (
          <AuthLayout>
            <ForgotPassword />
          </AuthLayout>
        ),
      },
      {
        path: "auth/sign-up",
        element: (
          <AuthLayout>
            <SignUp signUpType="member" />
          </AuthLayout>
        ),
      },
      {
        path: "auth/sign-up/cooperative",
        element: (
          <AuthLayout>
            <SignUp signUpType="cooperative" />
          </AuthLayout>
        ),
      },
      {
        path: "app/overview",
        element: (
          <AppLayout>
            <Protected>
              <Overview />
            </Protected>
          </AppLayout>
        ),
      },
      {
        path: "app/settings",
        element: (
          <AppLayout title="Settings">
            <Protected>
              <Settings />
            </Protected>
          </AppLayout>
        ),
      },
      {
        path: "app/settings/profile/edit",
        element: (
          <AppLayout title="Edit Profile" backTo="/app/settings">
            <Protected>
              <ProfileEdit />
            </Protected>
          </AppLayout>
        ),
      },
      {
        path: "app/settings/membership-settings/edit",
        element: (
          <AppLayout title="Membership Settings" backTo="/app/settings">
            <Protected>
              <MembershipSettingsEdit />
            </Protected>
          </AppLayout>
        ),
      },
      {
        path: "app/cooperative/:slug/:id/join",
        element: (
          <PlainLayout title="Join Cooperative" backTo="/app/overview">
            <Protected>
              <JoinCooperative />
            </Protected>
          </PlainLayout>
        ),
      },
      {
        path: "app/invitations",
        element: (
          <AppLayout title="Invitations" backTo="/app/overview">
            <Protected>
              <Invitation />
            </Protected>
          </AppLayout>
        ),
      },
      {
        path: "app/invitations/loan/guarantee",
        element: (
          <AppLayout title="Guarantee a Loan" backTo="/app/overview">
            <Protected>
              <LoanGuarantorInvitation />
            </Protected>
          </AppLayout>
        ),
      },
      {
        path: "app/approvals",
        element: (
          <AppLayout title="Approvals">
            <Protected>
              <Approvals />
            </Protected>
          </AppLayout>
        ),
      },
      {
        path: "app/approvals/:id",
        element: (
          <AppLayout
            title="Approvals"
            backTo="/app/approvals"
            bodyClassName="max-md:!px-0 max-md:!pt-0"
          >
            {({ pageScrollProgress }) => {
              return (
                <Protected>
                  <SingleCooperativeApproval
                    pageScrollProgress={pageScrollProgress}
                  />
                </Protected>
              );
            }}
          </AppLayout>
        ),
      },
      {
        path: "app/my-cooperatives",
        element: (
          <AppLayout title="Cooperatives">
            <Protected>
              <MyCooperatives />
            </Protected>
          </AppLayout>
        ),
      },
      {
        path: "app/my-cooperatives/:id",
        element: (
          <AppLayout title="Cooperatives" backTo="/app/my-cooperatives">
            <Protected>
              <SingleMyCooperative />
            </Protected>
          </AppLayout>
        ),
      },
      {
        path: "app/my-cooperatives/:title/:id",
        element: (
          <AppLayout title="Cooperatives" backTo="/app/my-cooperatives">
            <Protected>
              <SingleMyCooperative />
            </Protected>
          </AppLayout>
        ),
      },
      {
        path: "app/my-cooperatives/:cooperativeId/loan/:id/:type/view",
        element: (
          <AppLayout title="Loan Details" backTo={"-1"}>
            <Protected>
              <ViewLoanDetailsPage />
            </Protected>
          </AppLayout>
        ),
      },
      {
        path: "*",
        element: <Error404Page />,
      },
    ],
  },
];
